import { Modal } from "@pionex-web-kit/components";
import React from "react";
import { of } from "rxjs";
import { fromPromise } from "rxjs/internal-compatibility";
import { catchError, timeout } from "rxjs/operators";
import { ReCaptchaApi } from "./ReCaptchaApi";
import { jsx as _jsx } from "react/jsx-runtime";
function requestReCaptchaPromise(params) {
  if (params.keyType === "score") {
    return ReCaptchaApi.shared.getScoreToken(params);
  }
  return new Promise(function (resolve, reject) {
    var modal = Modal.info({
      maskClosable: true,
      width: "auto",
      className: "pi-re-captcha-provider-modal",
      mobileSwitch: false,
      content: /*#__PURE__*/_jsx("div", {
        ref: function ref(container) {
          if (container) {
            ReCaptchaApi.shared.getWidgetToken(container, params).then(function (token) {
              modal.destroy();
              resolve(token);
            }).catch(function (error) {
              modal.destroy();
              reject(error);
            });
          }
        }
      }),
      onCancel: function onCancel() {
        reject({
          code: -10,
          message: "ReCaptcha cancel"
        });
      }
    });
  });
}
export function requestReCaptcha(params) {
  var requestObservable = fromPromise(requestReCaptchaPromise(params));
  if (params.keyType === "score") {
    return requestObservable.pipe(timeout(5000), catchError(function () {
      return of({
        captcha_token: "Limited access"
      });
    }));
  } else {
    return requestObservable;
  }
}